import { render, staticRenderFns } from "./CurationWriteComponent.vue?vue&type=template&id=083f58f4&scoped=true"
import script from "./CurationWriteComponent.vue?vue&type=script&lang=js"
export * from "./CurationWriteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f58f4",
  null
  
)

export default component.exports